module.exports = __webpack_public_path__ + "img/hawaii.3100682e.jpg";